<template>
  <div class="dashboard-view tw-pt-16">
    <ChatHeader
      class="header tw-flex-none tw-fixed tw-top-0 tw-w-full"
    ></ChatHeader>
    <main class="dashboard-content tw-p-8 tw-text-left tw-space-y-8">
      <h1 class="tw-text-2xl tw-text-primary tw-font-bold tw-select-none">
        Dashboard
      </h1>
      <CurrentData />
      <StatisticalData />
      <AgentReport />
      <TagReport />
    </main>
  </div>
</template>

<script>
export default {
  name: "DashboardView",
  components: {
    ChatHeader: () => import("@/ui/components/chat/ChatHeader.vue"),
    TagReport: () => import("@/ui/pages/chat/dashboard/TagReport.vue"),
    AgentReport: () => import("@/ui/pages/chat/dashboard/AgentReport.vue"),
    CurrentData: () => import("@/ui/pages/chat/dashboard/CurrentData.vue"),
    StatisticalData: () =>
      import("@/ui/pages/chat/dashboard/StatisticalData.vue"),
  },
  data() {
    return {};
  },
  async mounted() {
    this.$store.dispatch("chat/listAgent");
    this.$store.dispatch("chat/listTags");
  },
  filters: {
    numFormat(value) {
      return value?.toLocaleString();
    },
  },
};
</script>

<style>

</style>
